'use client';

import { FC } from 'react';

import { clsx } from 'clsx';
import Link from 'next/link';

import { useProductVariant } from '../../hooks/useProductVariant';
import { ProductVariantType } from '../../model/types/productCard';
import { Slider } from '../Slider/Slider';
import { Bot } from './Bot/Bot';
import { Info } from './Info/Info';
import cls from './CardVariant.module.scss';

export const CardVariant: FC<ProductVariantType> = ({ data, comparisonPage }) => {
  const { hover, url, mouseOnHaler, mouseLeaveHandler } = useProductVariant(data);

  const images = data.images?.slice(0, 4);

  return (
    <div
      data-testid={'product-card-grid'}
      onMouseLeave={mouseLeaveHandler}
      onMouseOver={mouseOnHaler}
      className={clsx(cls.wrap, { [cls.comparisonPage]: comparisonPage })}
    >
      <Link
        aria-label={`Перейти на страницу товара ${data.name}`}
        href={url}
        className={cls.link}
      >
        {images && images.length > 0 ? (
          <Slider
            variant={'card'}
            slides={images}
            hovered={hover}
            productName={data.name}
            advantages={data.advantages}
          />
        ) : (
          <div className={cls.empty}>нет фото</div>
        )}

        <Info
          price={data.price}
          name={data.seoName || data.name}
          width={data.width}
          height={data.height}
          depth={data.depth}
          subCategory={data.subCategory}
          backlightType={data.backlightType}
          rating={data.rating}
        />
      </Link>
      <Bot
        comparisonPage={comparisonPage}
        {...{ ...data, url }}
        selected={false}
        quantity={1}
      />
    </div>
  );
};
